import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { StopPropagationModule } from '@y42/core/stop-propagation';
import { DataTestShowDialogCellRendererComponent } from './data-test-show-dialog-cell-renderer.component';

@NgModule({
  declarations: [DataTestShowDialogCellRendererComponent],
  imports: [CommonModule, StopPropagationModule, MatButtonModule, FontAwesomeModule, MatTooltipModule],
  exports: [DataTestShowDialogCellRendererComponent],
})
export class DataTestShowDialogCellRendererModule {}
